import { FormItemTypes, isNullOrUndefined } from '@bimser/core';
import classNames from 'classnames/bind';
import React from 'react';
import Styles from './assets/styles.scss';
import Component from './Component';
import { IColumn } from './entities';

const cx = classNames.bind(Styles);

const Column = (args: IColumn) => {
	const {
		data,
		getItem,
		controlRenderManager,
		deviceType,
		paddingType,
		parentItemType,
		isControlVisible
	} = args;

	const columnClassNames: string = cx({
		base: true,
		isInputGroup: parentItemType === FormItemTypes.EControlTypes.InputGroup,
		column: true
	});

	const width = data.designerProps.layout.get('width');
	const padding = data.designerProps.layout.get('padding');
	const noWidth = isNullOrUndefined(width) || width === '';
	let columnLayoutStyles: React.CSSProperties = noWidth
		? {}
		: {
				flex: '0 0 ' + width
		  };

	if (Object.keys(columnLayoutStyles).length) {
		columnLayoutStyles.padding = padding;
	} else {
		const noPadding = isNullOrUndefined(padding) || padding === '';
		columnLayoutStyles = noPadding
			? { padding: '0px 10px 0px 10px' }
			: {
					padding: padding
			  };
	}

	const someChildrenVisible = data?.items.filter(isControlVisible);
	if (!someChildrenVisible.count()) {
		return null;
	}

	return (
		<div
			className={columnClassNames}
			style={columnLayoutStyles}
		>
			{data.items.map(componentId => {
				const component = getItem(componentId as string);

				if (component) {
					return (
						<React.Fragment key={componentId as string}>
							<Component
								key={component.id}
								data={component}
								controlRenderManager={controlRenderManager}
								deviceType={deviceType}
								paddingType={paddingType}
								parentItemType={parentItemType}
							/>
						</React.Fragment>
					);
				}
			})}
		</div>
	);
};

export default Column;
